// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================
   ADMIN ARTICLES PAGE — CSS COMPLET
   Objectif: Mobile sans scroll horizontal (mode "cards" comme Paiements)
========================================= */

.adminArticlesPage {
  background: var(--white-principale);
  min-height: 100vh;
  padding: 12px 0 26px;
  font-family: Arial, sans-serif;
}

.adminArticlesGrid {
  display: flex;
  justify-content: center;
}

.adminArticlesCard {
  border-radius: 12px;
  background: var(--white-principale);
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.14);
  padding: 16px;
}

.adminArticlesCardCenter {
  width: 100%;
  /* max-width: 1300px; */
  margin-top: 16px;
  overflow: hidden;
  /* anti débordements (mobile) */
}

/* =========================
   HEADER
========================= */
.adminArticlesHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.adminArticlesTitle {
  font-weight: 900;
  font-size: 14px;
  color: var(--couleur-dark);
}

.adminArticlesSubtitle {
  margin-top: 4px;
  font-size: 12px;
  color: var(--gris-terciaire);
}

.adminArticlesHeaderRight {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

/* =========================
   BUTTONS
========================= */
.adminArticlesBtn {
  border: none;
  border-radius: 999px;
  padding: 8px 12px;
  font-weight: 800;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition:
    filter 0.15s ease,
    opacity 0.15s ease;
  text-decoration: none;
}

.adminArticlesBtnSoft {
  background: rgba(0, 0, 0, 0.06);
  color: var(--couleur-dark);
}

.adminArticlesBtnPrimary {
  background: rgba(43, 80, 255, 0.12);
  color: var(--couleur-principale);
}

.adminArticlesBtnSoft:hover,
.adminArticlesBtnPrimary:hover {
  filter: brightness(0.96);
}

.adminArticlesBtn:disabled {
  opacity: 0.6;
  cursor: default;
}

/* =========================
   FILTERS — RÉORGANISATION
========================= */
.adminArticlesFilters {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 12px 0 14px;
}

.adminArticlesFiltersRow {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.adminArticlesFiltersRow .adminArticlesSearch {
  flex: 1 1 280px;
  min-width: 220px;
}

.adminArticlesFiltersRow select {
  height: 34px;
  border-radius: 10px;
  border: 1px solid var(--gris-secondaire-2);
  padding: 0 10px;
  font-size: 12px;
  color: var(--couleur-dark);
  background: var(--white-principale);
  outline: none;
}

.adminArticlesSearch {
  flex: 1 1 360px;
  min-width: 260px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 999px;
  padding: 8px 12px;
  background: var(--white-principale);
}

.adminArticlesSearch input {
  flex: 1 1 auto;
  min-width: 0;
  border: none;
  outline: none;
  font-size: 12px;
  color: var(--couleur-dark);
  background: transparent;
}

.adminArticlesFiltersAdvanced {
  padding-top: 10px;
  border-top: 1px dashed var(--gris-secondaire-2);
  animation: adminArticlesFadeIn 0.15s ease;
}

@keyframes adminArticlesFadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.adminArticlesBtn.isActive {
  background: rgba(43, 80, 255, 0.14);
  color: var(--couleur-principale);
}

.adminArticlesDateRange {
  gap: 16px;
}

.adminArticlesDateField {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.adminArticlesDateField label {
  font-size: 11px;
  font-weight: 700;
  color: var(--gris-terciaire);
}

.adminArticlesDateField input[type="date"] {
  height: 34px;
  border-radius: 10px;
  border: 1px solid var(--gris-secondaire-2);
  padding: 0 10px;
  font-size: 12px;
  color: var(--couleur-dark);
  background: var(--white-principale);
  outline: none;
}

.adminArticlesDateResetBtn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid rgba(220, 53, 69, 0.24);
  background: var(--white-principale);
  color: var(--orange-principale);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 13px;
  align-self: flex-end;
  flex: 0 0 auto;
  transition:
    filter 0.15s ease,
    transform 0.06s ease;
}

.adminArticlesDateResetBtn:hover {
  filter: brightness(0.98);
}

.adminArticlesDateResetBtn:active {
  transform: scale(0.98);
}

@media (max-width: 720px) {
  .adminArticlesFiltersRow {
    flex-direction: column;
    align-items: stretch;
  }

  .adminArticlesFiltersRow select,
  .adminArticlesFiltersRow .adminArticlesAutocomplete {
    width: 100%;
  }

  .adminArticlesDateRange {
    flex-direction: row;
  }

  .adminArticlesDateField {
    flex: 1 1;
  }
}

/* =========================
   AUTO COMPLETE — SANS SCROLL HORIZONTAL
========================= */
.adminArticlesAutocomplete {
  position: relative;
  min-width: 220px;
}

.adminArticlesAutocomplete input {
  width: 100%;

  height: 34px;
  border-radius: 10px;
  border: 1px solid var(--gris-secondaire-2);
  padding: 0 10px;
  font-size: 12px;
  color: var(--couleur-dark);
  background: var(--white-principale);
  outline: none;
}

.adminArticlesAutocompleteDropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 100%;
  max-height: 260px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  z-index: 1000;
}

.adminArticlesAutocompleteItem {
  padding: 10px 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.adminArticlesAutocompleteItem:hover {
  background: #f5f5f5;
}


/* =========================
   TABLE
========================= */
.adminArticlesTableWrap {
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 12px;
}

.adminArticlesTable {
  width: 100%;
  border-collapse: collapse;
  min-width: 980px;
}

.adminArticlesTable thead th {
  text-align: left;
  font-size: 11px;
  color: var(--gris-terciaire);
  font-weight: 900;
  padding: 12px 12px;
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid var(--gris-secondaire-2);
}

.adminArticlesTable tbody td {
  position: relative;
  padding: 12px 12px;
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.06); */
  font-size: 12px;
  color: var(--couleur-dark);
  vertical-align: middle;
}

.adminArticlesTable tbody tr:hover {
  background: rgba(0, 0, 0, 0.02);
}

.muted {
  color: var(--gris-terciaire);
}

/* =========================
   ARTICLE CELL
========================= */
.adminArticlesCellItem {
  display: flex;
  align-items: center;
  gap: 10px;
  /* min-width: 260px; */
}

.adminArticlesThumb {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.06);
  overflow: hidden;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.adminArticlesThumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.adminArticlesCellItemText {
  min-width: 0;
}

.adminArticlesName {
  font-weight: 900;
  font-size: 12px;
  color: var(--couleur-dark);
  line-height: 1.1;
}

.adminArticlesId {
  margin-top: 2px;
  font-size: 10px;
  color: var(--gris-terciaire);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 360px;
}

/* =========================
   BADGES
========================= */
.adminArticlesBadge {
  display: inline-flex;
  align-items: center;
  height: 27px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.02em;
  border: 1px solid rgba(0, 0, 0, 0.08);
  width: 112px;
  justify-content: center;
}

.ms8 {
  margin-left: 8px;
}

.badgePremium {
  background: rgba(255, 193, 7, 0.16);
  color: #c78b00;
  border-color: rgba(255, 193, 7, 0.25);
}

.badgeStandard {
  background: rgba(0, 0, 0, 0.06);
  color: var(--couleur-dark);
}

.badgeActive {
  background: rgba(28, 180, 93, 0.12);
  color: #1cb45d;
  border-color: rgba(28, 180, 93, 0.18);
}

.badgeBlocked {
  background: rgba(220, 53, 69, 0.12);
  color: var(--orange-principale);
  border-color: rgba(220, 53, 69, 0.18);
}

.badgeArchived {
  background: rgba(108, 117, 125, 0.14);
  color: #6c757d;
  border-color: rgba(108, 117, 125, 0.22);
}

.badgeNotArchived {
  background: rgba(13, 110, 253, 0.12);
  color: #0d6efd;
  border-color: rgba(13, 110, 253, 0.18);
}

.badgeApproved {
  background: rgba(40, 167, 69, 0.12);
  color: #28a745;
  border-color: rgba(40, 167, 69, 0.18);
}

.badgeNotApproved {
  background: rgba(220, 53, 69, 0.12);
  color: var(--orange-principale);
  border-color: rgba(220, 53, 69, 0.18);
}

.badgePending {
  background: rgba(255, 193, 7, 0.16);
  color: #c78b00;
  border-color: rgba(255, 193, 7, 0.25);
}

.badgeExpired {
  background: rgba(220, 53, 69, 0.12);
  color: var(--orange-principale);
  border-color: rgba(220, 53, 69, 0.18);
}

.badgeTest {
  background: rgba(124, 58, 237, 0.18);
  color: #7c3aed;
  border-color: rgba(124, 58, 237, 0.25);
}

/* =========================
   ACTIONS
========================= */
.colActions {
  width: 160px;
}

.adminArticlesActions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: nowrap;
}

.adminArticlesIconBtn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: var(--white-principale);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    filter 0.15s ease,
    transform 0.06s ease;
  text-decoration: none;
  color: inherit;
}

.adminArticlesIconBtn:hover {
  filter: brightness(0.98);
}

.adminArticlesIconBtn:active {
  transform: scale(0.98);
}

.adminArticlesIconBtn.warning {
  border-color: rgba(255, 193, 7, 0.28);
  color: #c78b00;
}

.adminArticlesIconBtn.success {
  border-color: rgba(40, 167, 69, 0.24);
  color: #28a745;
}

.adminArticlesIconBtn.danger {
  border-color: rgba(220, 53, 69, 0.24);
  color: var(--orange-principale);
}

.adminArticlesIconBtn.sold {
  border-color: rgba(11, 0, 207, 0.22);
  color: var(--couleur-principale);
}

.adminArticlesIconBtn.test {
  border-color: rgba(124, 58, 237, 0.28);
  color: #7c3aed;
}

.adminArticlesIconBtn.notInterested {
  border-color: rgba(108, 117, 125, 0.28);
  color: #6c757d;
}

.adminArticlesIconBtn.expired {
  border-color: rgba(220, 53, 69, 0.24);
  color: var(--orange-principale);
}

/* =========================
   EMPTY / LOADER
========================= */
.adminArticlesEmpty {
  padding: 22px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: var(--gris-terciaire);
  text-align: center;
}

.adminArticlesEmpty i {
  font-size: 22px;
}

.adminArticlesSpinner {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: 2px solid rgba(0, 0, 0, 0.18);
  border-top-color: rgba(0, 0, 0, 0.45);
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* =========================
   PAGINATION
========================= */
.adminArticlesPagination {
  margin-top: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.adminArticlesPageBtn {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: var(--white-principale);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    filter 0.15s ease,
    transform 0.06s ease;
}

.adminArticlesPageBtn:hover {
  filter: brightness(0.98);
}

.adminArticlesPageBtn:active {
  transform: scale(0.98);
}

.adminArticlesPageBtn:disabled {
  opacity: 0.55;
  cursor: default;
}

.adminArticlesPageInfo {
  font-size: 12px;
  color: var(--gris-terciaire);
}

/* =========================
   RESPONSIVE HELPERS
========================= */
.hideOnMobile {
  display: table-cell;
}

.adminArticlesMobileMeta {
  display: none;
}

/* BOUTTON APPROUVER L'ARTICLE */
.approval-dropdown {
  position: fixed;
  /* plus "absolute" : sort du flux du tableau/scroll */
  background: white;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  width: 170px;
  z-index: 999999;
  /* au-dessus de tout, y compris les modales de confirmation */
  overflow: hidden;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.approval-item {
  padding: 10px 15px;
  cursor: pointer;
  font-size: 14px;
  transition: 0.2s;
  width: 100%;
}

.approval-item:hover {
  background: #ddd9d9;
}

.approval-item.success {
  color: #16a34a;
}

.approval-item.danger {
  color: #dc2626;
}

.approval-item.warning {
  color: #d97706;
}

.adminArticlesSpinner {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  border: 2px solid rgba(0, 0, 0, 0.18);
  border-top-color: rgba(0, 0, 0, 0.45);
  animation: spin 0.8s linear infinite;
  margin: 10px;
}

/* =========================================
   MOBILE MODE — SANS SCROLL HORIZONTAL
   Même logique que AdminPaiementsPage
========================================= */
@media (max-width: 720px) {
  .adminArticlesBtn {
    padding: 8px 10px;
  }

  /* Header en colonne */
  .adminArticlesHeader {
    flex-direction: column;
    align-items: stretch;
  }

  .adminArticlesHeaderRight {
    justify-content: flex-end;
    flex-wrap: nowrap;
  }

  /* Filters : en colonne */
  .adminArticlesFilters {
    flex-direction: column;
    align-items: stretch;
  }

  .adminArticlesSearch {
    width: 100%;
    min-width: 0;
    flex: 1 1 auto;
  }

  .adminArticlesSelects {
    width: 100%;
  }

  .adminArticlesSelects select {
    width: 100%;
  }

  /* Masquer les colonnes desktop */
  .hideOnMobile {
    display: none !important;
  }

  /* Désactiver la table large */
  .adminArticlesTable {
    min-width: 0;
  }

  /* Masquer l'entête */
  .adminArticlesTable thead {
    display: none;
  }

  /* Wrap sans scroll */
  .adminArticlesTableWrap {
    border: none;
    overflow: auto;
  }

  /* tbody en colonne */
  .adminArticlesTable tbody {
    display: flex;
    flex-direction: row;
    gap: 10px;
  }

  /* tr en card */
  .adminArticlesTable tbody tr {
    display: block;
    border: 1px solid var(--gris-secondaire-2);
    border-radius: 14px;
    padding: 10px;
    background: var(--white-principale);
  }

  /* td en bloc */
  .adminArticlesTable tbody td {
    display: block;
    border-bottom: none;
    padding: 6px 4px;
  }

  /* =========================
   ÉTAT DE LIGNE : VENDU
========================= */
  .adminArticlesTable tbody tr.rowSold {
    background: rgba(11, 0, 207, 0.06);
    border-left: 3px solid var(--couleur-principale);
  }

  .adminArticlesTable tbody tr.rowSold:hover {
    background: rgba(11, 0, 207, 0.1);
  }

  .adminArticlesTable tbody tr.rowSold td:first-child {
    padding-left: 9px;
  }

  @media (max-width: 720px) {
    .adminArticlesTable tbody tr.rowSold {
      background: rgba(11, 0, 207, 0.06);
      border: 1px solid rgba(11, 0, 207, 0.2);
      border-left: 3px solid var(--couleur-principale);
    }
  }

  /* anti overflow */
  .adminArticlesCellItem {
    min-width: 0;
  }

  .adminArticlesCellItemText {
    min-width: 0;
  }

  .adminArticlesName {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  /* Meta mobile visible */
  .adminArticlesMobileMeta {
    display: block;
    margin-top: 8px;
    font-size: 11px;
    color: var(--gris-terciaire);
    line-height: 1.35;
  }

  .adminArticlesMobileMeta div {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 4px;
  }

  /* actions width auto */
  .colActions {
    width: auto;
  }

  .adminArticlesActions {
    justify-content: center;
    margin-top: 6px;
  }
}

.adminArticlesModalOverlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
}

.adminArticlesModal {
  width: 100%;
  max-width: 390px;
  background: var(--white-principale);
  border-radius: 18px;
  padding: 22px;
  text-align: center;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22);
  animation: adminArticlesModalIn 0.18s ease;
}

@keyframes adminArticlesModalIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.adminArticlesModalIcon {
  width: 52px;
  height: 52px;
  border-radius: 999px;
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(220, 53, 69, 0.1);
  color: var(--orange-principale);
  font-size: 24px;
}

.adminArticlesModal h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 900;
  color: var(--couleur-dark);
}

.adminArticlesModal p {
  margin: 10px 0;
  font-size: 13px;
  color: var(--gris-terciaire);
  line-height: 1.45;
}

.adminArticlesModalArticle {
  margin: 12px auto 18px;
  display: inline-flex;
  padding: 7px 13px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.05);
  font-size: 12px;
  font-weight: 800;
  color: var(--couleur-dark);
}

.adminArticlesModalActions {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.adminArticlesModalCancel,
.adminArticlesModalConfirm {
  border: none;
  border-radius: 999px;
  padding: 9px 16px;
  font-size: 12px;
  font-weight: 900;
  cursor: pointer;
}

.adminArticlesModalCancel {
  background: rgba(0, 0, 0, 0.07);
  color: var(--couleur-dark);
}

.adminArticlesModalConfirm.danger {
  background: var(--orange-principale);
  color: #fff;
}

.adminArticlesModalConfirm.success {
  background: #1cb45d;
  color: #fff;
}

.adminArticlesModalConfirm.warning {
  background: #ffc107;
  color: #2b2b2b;
}

/* =========================
   ÉTAT DE LIGNE : EXPIRÉ
========================= */
.adminArticlesTable tbody tr.rowExpired {
  background: rgba(220, 53, 69, 0.09);
  border-left: 3px solid var(--orange-principale);
}

.adminArticlesTable tbody tr.rowExpired:hover {
  background: rgba(220, 53, 69, 0.14);
}

.adminArticlesTable tbody tr.rowExpired td:first-child {
  padding-left: 9px;
}

@media (max-width: 720px) {
  .adminArticlesTable tbody tr.rowExpired {
    background: rgba(220, 53, 69, 0.086);
    border: 1px solid rgba(220, 53, 69, 0.25);
    border-left: 3px solid var(--orange-principale);
  }
}

/* =========================
   ÉTAT DE LIGNE : TEST
========================= */
.adminArticlesTable tbody tr.rowTest {
  background: rgb(124 58 237 / 18%);
  border-left: 3px solid var(--kpi-users-fg);
}

.adminArticlesTable tbody tr.rowTest:hover {
  background: rgba(124, 58, 237, 0.14);
}

.adminArticlesTable tbody tr.rowTest td:first-child {
  padding-left: 9px;
}

@media (max-width: 720px) {
  .adminArticlesTable tbody tr.rowTest {
    background: rgb(124 58 237 / 18%);
    border: 1px solid rgba(124, 58, 237, 0.25);
    border-left: 3px solid var(--kpi-users-fg);
  }
}

.adminArticlesReactionItem {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #555;
}

.adminArticlesReactionItem i {
  font-size: 0.9rem;
  opacity: 0.75;
}

.adminArticlesReactionItem i {
  font-size: 0.9rem;
}

.icon-vue {
  color: #3b82f6;
  /* bleu */
}

.icon-favori {
  color: #ef4444;
  /* rouge */
}

.icon-message {
  color: #22c55e;
  /* vert */
}

.icon-appel {
  color: #f59e0b;
  /* orange */
}

.icon-whatsapp {
  color: #25d366;
  /* vert whatsapp officiel */
}

.icon-facebook {
  color: #1877f2;
  /* bleu facebook officiel */
}

.adminArticlesReactionMultiSelect {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
}

.adminArticlesReactionMultiSelectLabel {
  font-size: 0.75rem;
  color: #666;
  font-weight: 600;
}

.adminArticlesReactionCheckbox {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.82rem;
  cursor: pointer;
  white-space: nowrap;
}

.adminArticlesReactionGroup {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.adminArticlesReactionGroupLabel {
  font-size: 0.68rem;
  font-weight: 700;
  color: var(--gris-terciaire);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  min-width: 60px;
}

/* Tableau */
.adminArticlesReactions {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.adminArticlesReactionCol {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.adminArticlesReactionColTitle {
  font-size: 0.62rem;
  font-weight: 800;
  color: var(--gris-terciaire);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.adminArticlesReactionRow {
  display: flex;
  gap: 6px;
}

.adminArticlesReactionPill {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--couleur-dark);
  background: rgba(0, 0, 0, 0.035);
  border-radius: 999px;
  padding: 1px 6px;
  line-height: 1.4;
}

.adminArticlesReactionPill i {
  font-size: 0.72rem;
}

@media (max-width: 720px) {
  .adminArticlesReactions {
    flex-wrap: wrap;
    gap: 10px;
  }

  .adminArticlesFiltersRow .adminArticlesSearch {
    flex: 1 1 43px;
    min-width: 220px;
  }
}

/* =========================
   LÉGENDE DES STATUTS
========================= */
.adminArticlesLegend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 16px;
  padding: 10px 12px;
  margin-bottom: 12px;
  border: 1px solid var(--gris-secondaire-2);
  border-radius: 12px;
  background: var(--gris-foncer);
}

.adminArticlesLegendTitle {
  font-size: 11px;
  font-weight: 900;
  color: var(--gris-terciaire);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.adminArticlesLegendItem {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  color: var(--couleur-dark);
  white-space: nowrap;
  border: 1px solid transparent;
  background: transparent;
  border-radius: 999px;
  padding: 4px 10px 4px 8px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.adminArticlesLegendItem:hover {
  background: rgba(0, 0, 0, 0.04);
}

.adminArticlesLegendItem.active {
  background: var(--white-principale);
  border-color: rgba(0, 0, 0, 0.14);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.adminArticlesLegendClear {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  color: var(--orange-principale);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 6px;
  margin-left: 4px;
}

.adminArticlesLegendClear:hover {
  text-decoration: underline;
}

.adminArticlesLegendDot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex: 0 0 auto;
  display: inline-block;
}

.dotTest {
  background: #7c3aed;
}

.dotSold {
  background: var(--couleur-principale);
}

.dotNotInterested {
  background: #6c757d;
}

.dotExpired {
  background: var(--orange-principale);
}

.dotApproved {
  background: #28a745;
}

.dotNotApproved {
  background: var(--orange-principale);
}

.dotPending {
  background: #c78b00;
}

@media (max-width: 720px) {
  .adminArticlesLegend {
    gap: 8px 12px;
  }
}

.badgeSold {
  background: rgba(11, 0, 207, 0.1);
  color: var(--couleur-principale);
  border-color: rgba(11, 0, 207, 0.18);
}

.badgeNotInterested {
  background: rgba(108, 117, 125, 0.14);
  color: #6c757d;
  border-color: rgba(108, 117, 125, 0.22);
}

/* ============================================================
   BADGE PAIEMENT (dernier paiement par article, hors boost)
   ============================================================ */
.adminArticlesPaiementCount {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.18);
  color: inherit;
  font-size: 10px;
  font-weight: 900;
  margin-left: 2px;
}

.adminArticlesBadgeClickable {
  border: none;
  cursor: pointer;
  font: inherit;
  transition: filter 0.15s ease, transform 0.1s ease;
}

.adminArticlesBadgeClickable:hover {
  filter: brightness(0.94);
}

.adminArticlesBadgeClickable:active {
  transform: scale(0.97);
}

.badgePaiementPaye {
  background: rgba(28, 180, 93, 0.12);
  color: #1cb45d;
}

.badgePaiementAttente {
  background: rgba(255, 193, 7, 0.15);
  color: #cc9a06;
}

.badgePaiementEchoue {
  background: rgba(220, 53, 69, 0.12);
  color: #dc3545;
}

.badgePaiementGratuit {
  background: rgba(11, 0, 207, 0.1);
  color: var(--couleur-principale);
}

.badgeNoPaiement {
  background: rgba(0, 0, 0, 0.06);
  color: var(--gris-terciaire);
  font-style: italic;
}

/* ============================================================
   MODAL DETAIL PAIEMENT
   ============================================================ */

.adminArticlesPaiementModal {
  max-width: 420px;
  text-align: left;
}

.adminArticlesPaiementModal h3 {
  text-align: center;
}

.adminArticlesPaiementModal .adminArticlesModalArticle {
  text-align: center;
}

.adminArticlesPaiementDetails {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 16px 0;
  border: 1px solid var(--gris-secondaire-2, #ddd);
  border-radius: 10px;
  padding: 14px 16px;
}

.adminArticlesPaiementRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  color: var(--couleur-dark, #1f2937);
}

.adminArticlesPaiementRow span:first-child {
  color: var(--gris-terciaire, rgba(0, 0, 0, 0.5));
}

.adminArticlesPaiementTotal {
  border-top: 1px dashed var(--gris-secondaire-2, #ddd);
  padding-top: 10px;
  margin-top: 4px;
  font-size: 14px;
}

.adminArticlesPaiementTotal b {
  color: var(--couleur-principale);
  font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/admin/gestionArticles/AdminArticlesPage.css"],"names":[],"mappings":"AAAA;;;2CAG2C;;AAE3C;EACE,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;2BAE2B;AAC3B;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR;;sBAEoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0CAA0C;EAC1C,oBAAoB;EACpB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,+CAA+C;EAC/C,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd;;wBAEsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAW;EACb;AACF;;AAEA;;2BAE2B;AAC3B;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;;EAEX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;;2BAE2B;AAC3B;EACE,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kDAAkD;EAClD,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;2BAE2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;;2BAE2B;AAC3B;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;;wBAEsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;;2BAE2B;AAC3B;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;2BAE2B;AAC3B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;wBAEsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;2BAE2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,qDAAqD;EACrD,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,6DAA6D;EAC7D,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,qCAAqC;EACrC,oCAAoC;EACpC,YAAY;AACd;;AAEA;;;2CAG2C;AAC3C;EACE;IACE,iBAAiB;EACnB;;EAEA,sBAAsB;EACtB;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA,yBAAyB;EACzB;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA,iCAAiC;EACjC;IACE,wBAAwB;EAC1B;;EAEA,8BAA8B;EAC9B;IACE,YAAY;EACd;;EAEA,qBAAqB;EACrB;IACE,aAAa;EACf;;EAEA,qBAAqB;EACrB;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA,qBAAqB;EACrB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA,eAAe;EACf;IACE,cAAc;IACd,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,mCAAmC;EACrC;;EAEA,eAAe;EACf;IACE,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;2BAEyB;EACzB;IACE,kCAAkC;IAClC,gDAAgD;EAClD;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE;MACE,kCAAkC;MAClC,uCAAuC;MACvC,gDAAgD;IAClD;EACF;;EAEA,kBAAkB;EAClB;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;EACjB;;EAEA,wBAAwB;EACxB;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;EACjB;;EAEA,uBAAuB;EACvB;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;2BAE2B;AAC3B;EACE,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,oCAAoC;IACpC,yCAAyC;IACzC,+CAA+C;EACjD;AACF;;AAEA;;2BAE2B;AAC3B;EACE,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,iCAAiC;IACjC,0CAA0C;IAC1C,0CAA0C;EAC5C;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;;2BAE2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,uCAAuC;AACzC;;AAEA;;iEAEiE;AACjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;iEAEiE;;AAEjE;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,qDAAqD;EACrD,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB","sourcesContent":["/* =========================================\n   ADMIN ARTICLES PAGE — CSS COMPLET\n   Objectif: Mobile sans scroll horizontal (mode \"cards\" comme Paiements)\n========================================= */\n\n.adminArticlesPage {\n  background: var(--white-principale);\n  min-height: 100vh;\n  padding: 12px 0 26px;\n  font-family: Arial, sans-serif;\n}\n\n.adminArticlesGrid {\n  display: flex;\n  justify-content: center;\n}\n\n.adminArticlesCard {\n  border-radius: 12px;\n  background: var(--white-principale);\n  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.14);\n  padding: 16px;\n}\n\n.adminArticlesCardCenter {\n  width: 100%;\n  /* max-width: 1300px; */\n  margin-top: 16px;\n  overflow: hidden;\n  /* anti débordements (mobile) */\n}\n\n/* =========================\n   HEADER\n========================= */\n.adminArticlesHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.adminArticlesTitle {\n  font-weight: 900;\n  font-size: 14px;\n  color: var(--couleur-dark);\n}\n\n.adminArticlesSubtitle {\n  margin-top: 4px;\n  font-size: 12px;\n  color: var(--gris-terciaire);\n}\n\n.adminArticlesHeaderRight {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n/* =========================\n   BUTTONS\n========================= */\n.adminArticlesBtn {\n  border: none;\n  border-radius: 999px;\n  padding: 8px 12px;\n  font-weight: 800;\n  font-size: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition:\n    filter 0.15s ease,\n    opacity 0.15s ease;\n  text-decoration: none;\n}\n\n.adminArticlesBtnSoft {\n  background: rgba(0, 0, 0, 0.06);\n  color: var(--couleur-dark);\n}\n\n.adminArticlesBtnPrimary {\n  background: rgba(43, 80, 255, 0.12);\n  color: var(--couleur-principale);\n}\n\n.adminArticlesBtnSoft:hover,\n.adminArticlesBtnPrimary:hover {\n  filter: brightness(0.96);\n}\n\n.adminArticlesBtn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n/* =========================\n   FILTERS — RÉORGANISATION\n========================= */\n.adminArticlesFilters {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 12px 0 14px;\n}\n\n.adminArticlesFiltersRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.adminArticlesFiltersRow .adminArticlesSearch {\n  flex: 1 1 280px;\n  min-width: 220px;\n}\n\n.adminArticlesFiltersRow select {\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid var(--gris-secondaire-2);\n  padding: 0 10px;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: var(--white-principale);\n  outline: none;\n}\n\n.adminArticlesSearch {\n  flex: 1 1 360px;\n  min-width: 260px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 999px;\n  padding: 8px 12px;\n  background: var(--white-principale);\n}\n\n.adminArticlesSearch input {\n  flex: 1 1 auto;\n  min-width: 0;\n  border: none;\n  outline: none;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: transparent;\n}\n\n.adminArticlesFiltersAdvanced {\n  padding-top: 10px;\n  border-top: 1px dashed var(--gris-secondaire-2);\n  animation: adminArticlesFadeIn 0.15s ease;\n}\n\n@keyframes adminArticlesFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.adminArticlesBtn.isActive {\n  background: rgba(43, 80, 255, 0.14);\n  color: var(--couleur-principale);\n}\n\n.adminArticlesDateRange {\n  gap: 16px;\n}\n\n.adminArticlesDateField {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.adminArticlesDateField label {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--gris-terciaire);\n}\n\n.adminArticlesDateField input[type=\"date\"] {\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid var(--gris-secondaire-2);\n  padding: 0 10px;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: var(--white-principale);\n  outline: none;\n}\n\n.adminArticlesDateResetBtn {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid rgba(220, 53, 69, 0.24);\n  background: var(--white-principale);\n  color: var(--orange-principale);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 13px;\n  align-self: flex-end;\n  flex: 0 0 auto;\n  transition:\n    filter 0.15s ease,\n    transform 0.06s ease;\n}\n\n.adminArticlesDateResetBtn:hover {\n  filter: brightness(0.98);\n}\n\n.adminArticlesDateResetBtn:active {\n  transform: scale(0.98);\n}\n\n@media (max-width: 720px) {\n  .adminArticlesFiltersRow {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .adminArticlesFiltersRow select,\n  .adminArticlesFiltersRow .adminArticlesAutocomplete {\n    width: 100%;\n  }\n\n  .adminArticlesDateRange {\n    flex-direction: row;\n  }\n\n  .adminArticlesDateField {\n    flex: 1 1 0;\n  }\n}\n\n/* =========================\n   AUTO COMPLETE — SANS SCROLL HORIZONTAL\n========================= */\n.adminArticlesAutocomplete {\n  position: relative;\n  min-width: 220px;\n}\n\n.adminArticlesAutocomplete input {\n  width: 100%;\n\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid var(--gris-secondaire-2);\n  padding: 0 10px;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  background: var(--white-principale);\n  outline: none;\n}\n\n.adminArticlesAutocompleteDropdown {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  width: 100%;\n  max-height: 260px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\n  z-index: 1000;\n}\n\n.adminArticlesAutocompleteItem {\n  padding: 10px 14px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.adminArticlesAutocompleteItem:hover {\n  background: #f5f5f5;\n}\n\n\n/* =========================\n   TABLE\n========================= */\n.adminArticlesTableWrap {\n  width: 100%;\n  overflow-x: auto;\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 12px;\n}\n\n.adminArticlesTable {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 980px;\n}\n\n.adminArticlesTable thead th {\n  text-align: left;\n  font-size: 11px;\n  color: var(--gris-terciaire);\n  font-weight: 900;\n  padding: 12px 12px;\n  background: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid var(--gris-secondaire-2);\n}\n\n.adminArticlesTable tbody td {\n  position: relative;\n  padding: 12px 12px;\n  /* border-bottom: 1px solid rgba(0, 0, 0, 0.06); */\n  font-size: 12px;\n  color: var(--couleur-dark);\n  vertical-align: middle;\n}\n\n.adminArticlesTable tbody tr:hover {\n  background: rgba(0, 0, 0, 0.02);\n}\n\n.muted {\n  color: var(--gris-terciaire);\n}\n\n/* =========================\n   ARTICLE CELL\n========================= */\n.adminArticlesCellItem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  /* min-width: 260px; */\n}\n\n.adminArticlesThumb {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.adminArticlesThumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.adminArticlesCellItemText {\n  min-width: 0;\n}\n\n.adminArticlesName {\n  font-weight: 900;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  line-height: 1.1;\n}\n\n.adminArticlesId {\n  margin-top: 2px;\n  font-size: 10px;\n  color: var(--gris-terciaire);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 360px;\n}\n\n/* =========================\n   BADGES\n========================= */\n.adminArticlesBadge {\n  display: inline-flex;\n  align-items: center;\n  height: 27px;\n  padding: 0 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 900;\n  letter-spacing: 0.02em;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  width: 112px;\n  justify-content: center;\n}\n\n.ms8 {\n  margin-left: 8px;\n}\n\n.badgePremium {\n  background: rgba(255, 193, 7, 0.16);\n  color: #c78b00;\n  border-color: rgba(255, 193, 7, 0.25);\n}\n\n.badgeStandard {\n  background: rgba(0, 0, 0, 0.06);\n  color: var(--couleur-dark);\n}\n\n.badgeActive {\n  background: rgba(28, 180, 93, 0.12);\n  color: #1cb45d;\n  border-color: rgba(28, 180, 93, 0.18);\n}\n\n.badgeBlocked {\n  background: rgba(220, 53, 69, 0.12);\n  color: var(--orange-principale);\n  border-color: rgba(220, 53, 69, 0.18);\n}\n\n.badgeArchived {\n  background: rgba(108, 117, 125, 0.14);\n  color: #6c757d;\n  border-color: rgba(108, 117, 125, 0.22);\n}\n\n.badgeNotArchived {\n  background: rgba(13, 110, 253, 0.12);\n  color: #0d6efd;\n  border-color: rgba(13, 110, 253, 0.18);\n}\n\n.badgeApproved {\n  background: rgba(40, 167, 69, 0.12);\n  color: #28a745;\n  border-color: rgba(40, 167, 69, 0.18);\n}\n\n.badgeNotApproved {\n  background: rgba(220, 53, 69, 0.12);\n  color: var(--orange-principale);\n  border-color: rgba(220, 53, 69, 0.18);\n}\n\n.badgePending {\n  background: rgba(255, 193, 7, 0.16);\n  color: #c78b00;\n  border-color: rgba(255, 193, 7, 0.25);\n}\n\n.badgeExpired {\n  background: rgba(220, 53, 69, 0.12);\n  color: var(--orange-principale);\n  border-color: rgba(220, 53, 69, 0.18);\n}\n\n.badgeTest {\n  background: rgba(124, 58, 237, 0.18);\n  color: #7c3aed;\n  border-color: rgba(124, 58, 237, 0.25);\n}\n\n/* =========================\n   ACTIONS\n========================= */\n.colActions {\n  width: 160px;\n}\n\n.adminArticlesActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-wrap: nowrap;\n}\n\n.adminArticlesIconBtn {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: var(--white-principale);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition:\n    filter 0.15s ease,\n    transform 0.06s ease;\n  text-decoration: none;\n  color: inherit;\n}\n\n.adminArticlesIconBtn:hover {\n  filter: brightness(0.98);\n}\n\n.adminArticlesIconBtn:active {\n  transform: scale(0.98);\n}\n\n.adminArticlesIconBtn.warning {\n  border-color: rgba(255, 193, 7, 0.28);\n  color: #c78b00;\n}\n\n.adminArticlesIconBtn.success {\n  border-color: rgba(40, 167, 69, 0.24);\n  color: #28a745;\n}\n\n.adminArticlesIconBtn.danger {\n  border-color: rgba(220, 53, 69, 0.24);\n  color: var(--orange-principale);\n}\n\n.adminArticlesIconBtn.sold {\n  border-color: rgba(11, 0, 207, 0.22);\n  color: var(--couleur-principale);\n}\n\n.adminArticlesIconBtn.test {\n  border-color: rgba(124, 58, 237, 0.28);\n  color: #7c3aed;\n}\n\n.adminArticlesIconBtn.notInterested {\n  border-color: rgba(108, 117, 125, 0.28);\n  color: #6c757d;\n}\n\n.adminArticlesIconBtn.expired {\n  border-color: rgba(220, 53, 69, 0.24);\n  color: var(--orange-principale);\n}\n\n/* =========================\n   EMPTY / LOADER\n========================= */\n.adminArticlesEmpty {\n  padding: 22px 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: var(--gris-terciaire);\n  text-align: center;\n}\n\n.adminArticlesEmpty i {\n  font-size: 22px;\n}\n\n.adminArticlesSpinner {\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  border: 2px solid rgba(0, 0, 0, 0.18);\n  border-top-color: rgba(0, 0, 0, 0.45);\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* =========================\n   PAGINATION\n========================= */\n.adminArticlesPagination {\n  margin-top: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.adminArticlesPageBtn {\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background: var(--white-principale);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition:\n    filter 0.15s ease,\n    transform 0.06s ease;\n}\n\n.adminArticlesPageBtn:hover {\n  filter: brightness(0.98);\n}\n\n.adminArticlesPageBtn:active {\n  transform: scale(0.98);\n}\n\n.adminArticlesPageBtn:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n.adminArticlesPageInfo {\n  font-size: 12px;\n  color: var(--gris-terciaire);\n}\n\n/* =========================\n   RESPONSIVE HELPERS\n========================= */\n.hideOnMobile {\n  display: table-cell;\n}\n\n.adminArticlesMobileMeta {\n  display: none;\n}\n\n/* BOUTTON APPROUVER L'ARTICLE */\n.approval-dropdown {\n  position: fixed;\n  /* plus \"absolute\" : sort du flux du tableau/scroll */\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);\n  width: 170px;\n  z-index: 999999;\n  /* au-dessus de tout, y compris les modales de confirmation */\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n\n.approval-item {\n  padding: 10px 15px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: 0.2s;\n  width: 100%;\n}\n\n.approval-item:hover {\n  background: #ddd9d9;\n}\n\n.approval-item.success {\n  color: #16a34a;\n}\n\n.approval-item.danger {\n  color: #dc2626;\n}\n\n.approval-item.warning {\n  color: #d97706;\n}\n\n.adminArticlesSpinner {\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  border: 2px solid rgba(0, 0, 0, 0.18);\n  border-top-color: rgba(0, 0, 0, 0.45);\n  animation: spin 0.8s linear infinite;\n  margin: 10px;\n}\n\n/* =========================================\n   MOBILE MODE — SANS SCROLL HORIZONTAL\n   Même logique que AdminPaiementsPage\n========================================= */\n@media (max-width: 720px) {\n  .adminArticlesBtn {\n    padding: 8px 10px;\n  }\n\n  /* Header en colonne */\n  .adminArticlesHeader {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .adminArticlesHeaderRight {\n    justify-content: flex-end;\n    flex-wrap: nowrap;\n  }\n\n  /* Filters : en colonne */\n  .adminArticlesFilters {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .adminArticlesSearch {\n    width: 100%;\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  .adminArticlesSelects {\n    width: 100%;\n  }\n\n  .adminArticlesSelects select {\n    width: 100%;\n  }\n\n  /* Masquer les colonnes desktop */\n  .hideOnMobile {\n    display: none !important;\n  }\n\n  /* Désactiver la table large */\n  .adminArticlesTable {\n    min-width: 0;\n  }\n\n  /* Masquer l'entête */\n  .adminArticlesTable thead {\n    display: none;\n  }\n\n  /* Wrap sans scroll */\n  .adminArticlesTableWrap {\n    border: none;\n    overflow: auto;\n  }\n\n  /* tbody en colonne */\n  .adminArticlesTable tbody {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n  }\n\n  /* tr en card */\n  .adminArticlesTable tbody tr {\n    display: block;\n    border: 1px solid var(--gris-secondaire-2);\n    border-radius: 14px;\n    padding: 10px;\n    background: var(--white-principale);\n  }\n\n  /* td en bloc */\n  .adminArticlesTable tbody td {\n    display: block;\n    border-bottom: none;\n    padding: 6px 4px;\n  }\n\n  /* =========================\n   ÉTAT DE LIGNE : VENDU\n========================= */\n  .adminArticlesTable tbody tr.rowSold {\n    background: rgba(11, 0, 207, 0.06);\n    border-left: 3px solid var(--couleur-principale);\n  }\n\n  .adminArticlesTable tbody tr.rowSold:hover {\n    background: rgba(11, 0, 207, 0.1);\n  }\n\n  .adminArticlesTable tbody tr.rowSold td:first-child {\n    padding-left: 9px;\n  }\n\n  @media (max-width: 720px) {\n    .adminArticlesTable tbody tr.rowSold {\n      background: rgba(11, 0, 207, 0.06);\n      border: 1px solid rgba(11, 0, 207, 0.2);\n      border-left: 3px solid var(--couleur-principale);\n    }\n  }\n\n  /* anti overflow */\n  .adminArticlesCellItem {\n    min-width: 0;\n  }\n\n  .adminArticlesCellItemText {\n    min-width: 0;\n  }\n\n  .adminArticlesName {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n  }\n\n  /* Meta mobile visible */\n  .adminArticlesMobileMeta {\n    display: block;\n    margin-top: 8px;\n    font-size: 11px;\n    color: var(--gris-terciaire);\n    line-height: 1.35;\n  }\n\n  .adminArticlesMobileMeta div {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 4px;\n  }\n\n  /* actions width auto */\n  .colActions {\n    width: auto;\n  }\n\n  .adminArticlesActions {\n    justify-content: center;\n    margin-top: 6px;\n  }\n}\n\n.adminArticlesModalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 16px;\n}\n\n.adminArticlesModal {\n  width: 100%;\n  max-width: 390px;\n  background: var(--white-principale);\n  border-radius: 18px;\n  padding: 22px;\n  text-align: center;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22);\n  animation: adminArticlesModalIn 0.18s ease;\n}\n\n@keyframes adminArticlesModalIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px) scale(0.98);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.adminArticlesModalIcon {\n  width: 52px;\n  height: 52px;\n  border-radius: 999px;\n  margin: 0 auto 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(220, 53, 69, 0.1);\n  color: var(--orange-principale);\n  font-size: 24px;\n}\n\n.adminArticlesModal h3 {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 900;\n  color: var(--couleur-dark);\n}\n\n.adminArticlesModal p {\n  margin: 10px 0;\n  font-size: 13px;\n  color: var(--gris-terciaire);\n  line-height: 1.45;\n}\n\n.adminArticlesModalArticle {\n  margin: 12px auto 18px;\n  display: inline-flex;\n  padding: 7px 13px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.05);\n  font-size: 12px;\n  font-weight: 800;\n  color: var(--couleur-dark);\n}\n\n.adminArticlesModalActions {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n.adminArticlesModalCancel,\n.adminArticlesModalConfirm {\n  border: none;\n  border-radius: 999px;\n  padding: 9px 16px;\n  font-size: 12px;\n  font-weight: 900;\n  cursor: pointer;\n}\n\n.adminArticlesModalCancel {\n  background: rgba(0, 0, 0, 0.07);\n  color: var(--couleur-dark);\n}\n\n.adminArticlesModalConfirm.danger {\n  background: var(--orange-principale);\n  color: #fff;\n}\n\n.adminArticlesModalConfirm.success {\n  background: #1cb45d;\n  color: #fff;\n}\n\n.adminArticlesModalConfirm.warning {\n  background: #ffc107;\n  color: #2b2b2b;\n}\n\n/* =========================\n   ÉTAT DE LIGNE : EXPIRÉ\n========================= */\n.adminArticlesTable tbody tr.rowExpired {\n  background: rgba(220, 53, 69, 0.09);\n  border-left: 3px solid var(--orange-principale);\n}\n\n.adminArticlesTable tbody tr.rowExpired:hover {\n  background: rgba(220, 53, 69, 0.14);\n}\n\n.adminArticlesTable tbody tr.rowExpired td:first-child {\n  padding-left: 9px;\n}\n\n@media (max-width: 720px) {\n  .adminArticlesTable tbody tr.rowExpired {\n    background: rgba(220, 53, 69, 0.086);\n    border: 1px solid rgba(220, 53, 69, 0.25);\n    border-left: 3px solid var(--orange-principale);\n  }\n}\n\n/* =========================\n   ÉTAT DE LIGNE : TEST\n========================= */\n.adminArticlesTable tbody tr.rowTest {\n  background: rgb(124 58 237 / 18%);\n  border-left: 3px solid var(--kpi-users-fg);\n}\n\n.adminArticlesTable tbody tr.rowTest:hover {\n  background: rgba(124, 58, 237, 0.14);\n}\n\n.adminArticlesTable tbody tr.rowTest td:first-child {\n  padding-left: 9px;\n}\n\n@media (max-width: 720px) {\n  .adminArticlesTable tbody tr.rowTest {\n    background: rgb(124 58 237 / 18%);\n    border: 1px solid rgba(124, 58, 237, 0.25);\n    border-left: 3px solid var(--kpi-users-fg);\n  }\n}\n\n.adminArticlesReactionItem {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: #555;\n}\n\n.adminArticlesReactionItem i {\n  font-size: 0.9rem;\n  opacity: 0.75;\n}\n\n.adminArticlesReactionItem i {\n  font-size: 0.9rem;\n}\n\n.icon-vue {\n  color: #3b82f6;\n  /* bleu */\n}\n\n.icon-favori {\n  color: #ef4444;\n  /* rouge */\n}\n\n.icon-message {\n  color: #22c55e;\n  /* vert */\n}\n\n.icon-appel {\n  color: #f59e0b;\n  /* orange */\n}\n\n.icon-whatsapp {\n  color: #25d366;\n  /* vert whatsapp officiel */\n}\n\n.icon-facebook {\n  color: #1877f2;\n  /* bleu facebook officiel */\n}\n\n.adminArticlesReactionMultiSelect {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  padding: 6px 10px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n}\n\n.adminArticlesReactionMultiSelectLabel {\n  font-size: 0.75rem;\n  color: #666;\n  font-weight: 600;\n}\n\n.adminArticlesReactionCheckbox {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.82rem;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.adminArticlesReactionGroup {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.adminArticlesReactionGroupLabel {\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: var(--gris-terciaire);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  min-width: 60px;\n}\n\n/* Tableau */\n.adminArticlesReactions {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.adminArticlesReactionCol {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.adminArticlesReactionColTitle {\n  font-size: 0.62rem;\n  font-weight: 800;\n  color: var(--gris-terciaire);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.adminArticlesReactionRow {\n  display: flex;\n  gap: 6px;\n}\n\n.adminArticlesReactionPill {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: var(--couleur-dark);\n  background: rgba(0, 0, 0, 0.035);\n  border-radius: 999px;\n  padding: 1px 6px;\n  line-height: 1.4;\n}\n\n.adminArticlesReactionPill i {\n  font-size: 0.72rem;\n}\n\n@media (max-width: 720px) {\n  .adminArticlesReactions {\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n\n  .adminArticlesFiltersRow .adminArticlesSearch {\n    flex: 1 1 43px;\n    min-width: 220px;\n  }\n}\n\n/* =========================\n   LÉGENDE DES STATUTS\n========================= */\n.adminArticlesLegend {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 16px;\n  padding: 10px 12px;\n  margin-bottom: 12px;\n  border: 1px solid var(--gris-secondaire-2);\n  border-radius: 12px;\n  background: var(--gris-foncer);\n}\n\n.adminArticlesLegendTitle {\n  font-size: 11px;\n  font-weight: 900;\n  color: var(--gris-terciaire);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.adminArticlesLegendItem {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--couleur-dark);\n  white-space: nowrap;\n  border: 1px solid transparent;\n  background: transparent;\n  border-radius: 999px;\n  padding: 4px 10px 4px 8px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.adminArticlesLegendItem:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.adminArticlesLegendItem.active {\n  background: var(--white-principale);\n  border-color: rgba(0, 0, 0, 0.14);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.adminArticlesLegendClear {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--orange-principale);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 4px 6px;\n  margin-left: 4px;\n}\n\n.adminArticlesLegendClear:hover {\n  text-decoration: underline;\n}\n\n.adminArticlesLegendDot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  flex: 0 0 auto;\n  display: inline-block;\n}\n\n.dotTest {\n  background: #7c3aed;\n}\n\n.dotSold {\n  background: var(--couleur-principale);\n}\n\n.dotNotInterested {\n  background: #6c757d;\n}\n\n.dotExpired {\n  background: var(--orange-principale);\n}\n\n.dotApproved {\n  background: #28a745;\n}\n\n.dotNotApproved {\n  background: var(--orange-principale);\n}\n\n.dotPending {\n  background: #c78b00;\n}\n\n@media (max-width: 720px) {\n  .adminArticlesLegend {\n    gap: 8px 12px;\n  }\n}\n\n.badgeSold {\n  background: rgba(11, 0, 207, 0.1);\n  color: var(--couleur-principale);\n  border-color: rgba(11, 0, 207, 0.18);\n}\n\n.badgeNotInterested {\n  background: rgba(108, 117, 125, 0.14);\n  color: #6c757d;\n  border-color: rgba(108, 117, 125, 0.22);\n}\n\n/* ============================================================\n   BADGE PAIEMENT (dernier paiement par article, hors boost)\n   ============================================================ */\n.adminArticlesPaiementCount {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.18);\n  color: inherit;\n  font-size: 10px;\n  font-weight: 900;\n  margin-left: 2px;\n}\n\n.adminArticlesBadgeClickable {\n  border: none;\n  cursor: pointer;\n  font: inherit;\n  transition: filter 0.15s ease, transform 0.1s ease;\n}\n\n.adminArticlesBadgeClickable:hover {\n  filter: brightness(0.94);\n}\n\n.adminArticlesBadgeClickable:active {\n  transform: scale(0.97);\n}\n\n.badgePaiementPaye {\n  background: rgba(28, 180, 93, 0.12);\n  color: #1cb45d;\n}\n\n.badgePaiementAttente {\n  background: rgba(255, 193, 7, 0.15);\n  color: #cc9a06;\n}\n\n.badgePaiementEchoue {\n  background: rgba(220, 53, 69, 0.12);\n  color: #dc3545;\n}\n\n.badgePaiementGratuit {\n  background: rgba(11, 0, 207, 0.1);\n  color: var(--couleur-principale);\n}\n\n.badgeNoPaiement {\n  background: rgba(0, 0, 0, 0.06);\n  color: var(--gris-terciaire);\n  font-style: italic;\n}\n\n/* ============================================================\n   MODAL DETAIL PAIEMENT\n   ============================================================ */\n\n.adminArticlesPaiementModal {\n  max-width: 420px;\n  text-align: left;\n}\n\n.adminArticlesPaiementModal h3 {\n  text-align: center;\n}\n\n.adminArticlesPaiementModal .adminArticlesModalArticle {\n  text-align: center;\n}\n\n.adminArticlesPaiementDetails {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 16px 0;\n  border: 1px solid var(--gris-secondaire-2, #ddd);\n  border-radius: 10px;\n  padding: 14px 16px;\n}\n\n.adminArticlesPaiementRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 13px;\n  color: var(--couleur-dark, #1f2937);\n}\n\n.adminArticlesPaiementRow span:first-child {\n  color: var(--gris-terciaire, rgba(0, 0, 0, 0.5));\n}\n\n.adminArticlesPaiementTotal {\n  border-top: 1px dashed var(--gris-secondaire-2, #ddd);\n  padding-top: 10px;\n  margin-top: 4px;\n  font-size: 14px;\n}\n\n.adminArticlesPaiementTotal b {\n  color: var(--couleur-principale);\n  font-size: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
